<template>
    <span>
        <a target="_blank" class="hidden-lg-and-up"  href="https://wa.me/51919006885?text='Hola ChevereTech!, estoy interesado en...'"><img id="whatsapp" src="@/../public/assets/images/services/Whatsapp.png" alt="¡Háblanos!"></a>
        <a target="_blank" class="hidden-md-and-down" href="https://api.whatsapp.com/send?phone=51919006885&text='Hola ChevereTech!, estoy interesado en...'"><img id="whatsapp" src="@/../public/assets/images/services/Whatsapp.png" alt="¡Háblanos!"></a>
    </span>
</template>

<script>
export default {
    name: "Whatsapp"    
}
</script>

<style scoped>    
    #whatsapp{
        position:fixed;
        display:block;
        bottom:5%;
        right:5%;
        color:white;
        z-index: 999;
        cursor: pointer;
        width: 75px;
    }
    
</style>





// WEBPACK FOOTER //
// src/sections/Whatsapp.vue